import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { PrismBanner, PrismBreadcrumb } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';
import SettingsCompetitorsCompetitorPanel from 'lumen/components/settings/competitors/competitor-panel';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsCompetitorsGeneralController from 'lumen/controllers/hotel/settings/competitors/general';
import hasFeature from 'lumen/helpers/has-feature';

interface HotelSettingsCompetitorsGeneralSignature {
  Args: {
    controller: HotelSettingsCompetitorsGeneralController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate @isFullHeight={{true}} @title={{@controller.pageTitle}}>
    <:breadcrumb>
      <PrismBreadcrumb as |B|>
        <B.item
          @label={{t "general.competitors"}}
          @route="hotel.settings.competitors"
        />
        <B.item @isCurrent={{true}} @label={{@controller.pageTitle}} />
      </PrismBreadcrumb>
    </:breadcrumb>
    <:default>
      <div class="flex h-full flex-col gap-600">
        {{#unless @controller.canEditCurrentCompset}}
          <PrismBanner @bannerMessage={{t "general.viewer_banner"}} />
        {{/unless}}

        <div class="flex-1 overflow-auto">
          <SettingsCompetitorsCompetitorPanel
            @activeTab={{@controller.activeTab}}
            @hasNoRadiusLimit={{hasFeature "hotel.compset.no_radius_limit"}}
            @hotel={{@controller.hotelAndMarket.hotel}}
            @locale={{@controller.hotelAndMarket.user.locale}}
            @onCancel={{fn @controller.setHasUnsavedChanges false}}
            @onCompetitorsChange={{fn @controller.setHasUnsavedChanges true}}
            @onSuccess={{@controller.onSaveChangesSuccess}}
            {{! @glint-expect-error: Incorrect type }}
            @setActiveTab={{fn (mut @controller.activeTab)}}
            @showRMSCompset={{not
              @controller.access.isPricingAssistantStandaloneVersion
            }}
            @showSecondaryCompset={{not
              @controller.access.isPricingAssistantStandaloneVersion
            }}
          />
        </div>
      </div>
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsCompetitorsGeneralSignature>;
